module.exports = __webpack_public_path__ + "static/media/PxGroteskBoldItalic.1655fa10.ttf";